import React from "react";
import { MessageItem, Message } from "./MessageItem";

interface MessagesListProps {
  messages: Message[];
  isPrivate?: boolean;
  emptyMessage?: string;
}

export const MessagesList: React.FC<MessagesListProps> = ({
  messages,
  isPrivate = false,
  emptyMessage,
}) => {
  const defaultEmptyMessage = isPrivate
    ? "No messages yet. Connect with auth token and subscribe to user updates."
    : "No messages yet. Connect and subscribe to channels to see updates.";

  return (
    <div className={`messages-container ${isPrivate ? "private" : "public"}`}>
      {messages.length === 0 ? (
        <div className={`messages-empty ${isPrivate ? "private" : ""}`}>
          {emptyMessage || defaultEmptyMessage}
        </div>
      ) : (
        messages.map((msg) => <MessageItem key={msg.id} message={msg} />)
      )}
    </div>
  );
};

